module.exports = {
  lg: "0px 7px 35px rgba(0, 0, 0, 0.15)",
  xl: "0px 32px 48px rgba(0, 0, 0, 0.15)",
};
